import { render } from "./ByType.vue?vue&type=template&id=610f85d8"
import script from "./ByType.vue?vue&type=script&lang=js"
export * from "./ByType.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\ssd_ice\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__